// extracted by mini-css-extract-plugin
export var box = "_4j-0";
export var check = "_4j-1";
export var checkboxButton = "_4j-6";
export var checkboxGroup = "_4j-5";
export var disabled = "_4j-7";
export var ghost = "_4j-9";
export var input = "_4j-2";
export var label = "_4j-4";
export var normal = "_4j-8";
export var uncheck = "_4j-3";